import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

export const listItemText: {
  defaultProps?: ComponentsProps['MuiListItemText'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiListItemText'];
  variants?: ComponentsVariants<Theme>['MuiListItemText'];
} = {
  styleOverrides: {
    root({ theme }) {
      return {
        '.MuiTypography-root': {
          fontWeight: 500,
          ':hover': {
            background: 'transparent'
          },
          fontSize: theme.typography.body2.fontSize
        }
      };
    }
  }
};
